import './App.css';
import Navbar from './components/Navbar';
import { useMeta } from './hooks/useMeta';

function AnimacionLectora() {
    useMeta({
        title: 'Animación Lectora - MiMadre Universe',
        description: 'Programas de animación a la lectura desarrollados por Inmaculada Fuentes. Actividades educativas y culturales para fomentar el amor por la lectura.',
        image: '/portada_mimadre.avif',
        url: 'https://inmaculadafuentes.com/animacion-lectora'
    });

    return (
        <div className="app">
            <Navbar showHomeLink />

            <section className="book-page">
                <div className="book-hero">
                    <h1>Animación Lectora</h1>
                    <p>Programas y actividades para fomentar el amor por la lectura</p>
                </div>

                <div className="book-section">
                    <h2>Próximamente</h2>
                    <p>Esta sección estará disponible próximamente con información sobre nuestros programas de animación a la lectura.</p>
                </div>
            </section>
        </div>
    );
}

export default AnimacionLectora;